import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductCard from '../components/productCard';
import products from '../data/products';

function Home() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  const filters = ['All', 'Shoes', 'Clothing', 'Accessories', 'Sports'];
  const brands = [...new Set(products.map(p => p.brand))];

  const filteredProducts = products.filter(p => {
    const matchesFilter =
      activeFilter === 'All' ||
      p.category === activeFilter ||
      p.brand === activeFilter; // ← fixes brand filter clicks
    const matchesSearch =
      p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.brand.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const isFiltering = searchQuery !== '' || activeFilter !== 'All';

  return (
    <div style={{ background: '#080808', minHeight: '100vh', color: '#f0f0f0', fontFamily: 'DM Sans, sans-serif', paddingBottom: '120px' }}>

      {/* NAVBAR */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        padding: '16px 24px', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', background: 'rgba(8,8,8,0.9)',
        backdropFilter: 'blur(12px)', borderBottom: '1px solid #242424'
      }}>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', letterSpacing: '3px' }}>
          FIT<span style={{ color: '#ff3c00' }}>OFF</span>
        </div>
        <input
          placeholder="Search deals..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            background: '#1c1c1c', border: '1px solid #242424', borderRadius: '8px',
            padding: '8px 16px', color: '#f0f0f0', fontSize: '14px', width: '200px', outline: 'none'
          }}
        />
      </nav>

      {/* HERO */}
      <div style={{ marginTop: '70px', padding: '40px 24px 20px', position: 'relative', overflow: 'hidden' }}>
        <div style={{
          position: 'absolute', top: '-20px', right: '-40px',
          fontFamily: 'Bebas Neue, sans-serif', fontSize: '200px',
          color: 'rgba(255,60,0,0.04)', pointerEvents: 'none', lineHeight: 1
        }}>SALE</div>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          background: 'rgba(255,60,0,0.12)', border: '1px solid rgba(255,60,0,0.25)',
          borderRadius: '100px', padding: '4px 12px', fontSize: '12px',
          color: '#ff3c00', marginBottom: '16px', letterSpacing: '1px', textTransform: 'uppercase'
        }}>
          <div style={{ width: '7px', height: '7px', background: '#ff3c00', borderRadius: '50%' }}></div>
          Live Clearance
        </div>
        <h1 style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '64px', letterSpacing: '2px', lineHeight: '0.95', marginBottom: '16px' }}>
          ALL THE<br /><span style={{ color: '#ff3c00' }}>DEALS.</span><br />
          <span style={{ color: '#ffb800' }}>ONE APP.</span>
        </h1>
        <p style={{ color: '#606060', fontSize: '15px', maxWidth: '340px', lineHeight: '1.6', marginBottom: '28px' }}>
          Stop jumping between apps. Every brand's clearance — right here, updated daily.
        </p>
        <div style={{ display: 'flex', gap: '28px' }}>
          <div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', color: '#ffb800' }}>{brands.length}+</div>
            <div style={{ fontSize: '11px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px' }}>Brands</div>
          </div>
          <div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', color: '#ffb800' }}>{products.length}</div>
            <div style={{ fontSize: '11px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px' }}>Live Deals</div>
          </div>
          <div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', color: '#ffb800' }}>65%</div>
            <div style={{ fontSize: '11px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px' }}>Max Off</div>
          </div>
        </div>
      </div>

      {/* CATEGORY FILTERS */}
      <div style={{ padding: '0 24px 20px' }}>
        <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' }}>
          {filters.map(filter => (
            <button key={filter} onClick={() => setActiveFilter(filter)} style={{
              flexShrink: 0, padding: '8px 18px', borderRadius: '100px',
              fontSize: '13px', fontWeight: '500', cursor: 'pointer',
              border: '1px solid', fontFamily: 'DM Sans, sans-serif',
              borderColor: activeFilter === filter ? '#ff3c00' : '#242424',
              background: activeFilter === filter ? '#ff3c00' : 'transparent',
              color: activeFilter === filter ? 'white' : '#606060'
            }}>
              {filter}
            </button>
          ))}
        </div>
      </div>

      {/* SHOP BY BRAND — hide when actively searching */}
      {!isFiltering && (
        <div style={{ padding: '0 24px 32px' }}>
          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '2px', marginBottom: '16px' }}>
            SHOP BY BRAND
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
            {brands.map(brand => (
              <div key={brand} onClick={() => setActiveFilter(brand)} style={{
                background: '#131313', border: '1px solid #242424', borderRadius: '12px',
                padding: '16px 12px', textAlign: 'center', cursor: 'pointer'
              }}>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '18px', letterSpacing: '2px', marginBottom: '4px' }}>{brand}</div>
                <div style={{ fontSize: '11px', color: '#ff3c00', fontWeight: '600' }}>
                  {products.filter(p => p.brand === brand).length} deals
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* DEALS SECTION */}
      <div style={{ padding: '0 24px 32px' }}>
        {/* Header with result count */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '2px' }}>
            🔥 {searchQuery
              ? `RESULTS FOR "${searchQuery.toUpperCase()}"`
              : activeFilter === 'All'
              ? 'HOT RIGHT NOW'
              : activeFilter.toUpperCase()}
          </div>
          <div style={{ fontSize: '12px', color: '#606060' }}>
            {filteredProducts.length} deal{filteredProducts.length !== 1 ? 's' : ''}
          </div>
        </div>

        {/* Empty state */}
        {filteredProducts.length === 0 ? (
          <div style={{
            textAlign: 'center', padding: '60px 20px',
            background: '#131313', borderRadius: '16px',
            border: '1px solid #242424'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>🔍</div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '2px', marginBottom: '8px' }}>
              NO DEALS FOUND
            </div>
            <div style={{ color: '#606060', fontSize: '14px', marginBottom: '20px' }}>
              No results for "{searchQuery}" — try a different search or brand
            </div>
            <button
              onClick={() => { setSearchQuery(''); setActiveFilter('All'); }}
              style={{
                background: '#ff3c00', color: 'white', border: 'none',
                borderRadius: '8px', padding: '10px 24px', fontSize: '14px',
                fontWeight: '600', cursor: 'pointer', fontFamily: 'DM Sans, sans-serif'
              }}
            >
              Clear filters
            </button>
          </div>
        ) : (
          /* Grid layout — shows filtered results clearly instead of hiding off-screen */
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '12px'
          }}>
            {filteredProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>

      {/* PRIVACY LINK */}
      <div style={{ textAlign: 'center', padding: '16px 0 8px' }}>
        <span
          onClick={() => navigate('/privacy')}
          style={{ fontSize: '11px', color: '#606060', cursor: 'pointer', textDecoration: 'underline' }}
        >
          Privacy Policy
        </span>
      </div>

      {/* BOTTOM NAV */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        background: 'rgba(8,8,8,0.95)', backdropFilter: 'blur(12px)',
        borderTop: '1px solid #242424', display: 'flex', padding: '10px 0 20px'
      }}>
        {['Home', 'Search', 'Saved', 'Profile'].map((item, i) => (
          <div key={item} style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: '4px', cursor: 'pointer',
            opacity: i === 0 ? 1 : 0.4
          }}>
            <span style={{ fontSize: '20px' }}>
              {i === 0 ? '🏠' : i === 1 ? '🔍' : i === 2 ? '❤️' : '👤'}
            </span>
            <span style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', color: i === 0 ? '#ff3c00' : '#606060' }}>
              {item}
            </span>
          </div>
        ))}
      </div>

    </div>
  );
}

export default Home;